import {
    stepsList,
    mobileMenu,
    accordion,
    productList,
    productListFilters,
    bannerCarousel,
    bannerCarouselGreencare,
    searchForm,
    referenceList,
    referenceListFilters,
    mainMenu,
    sidePanel,
    shareLinks,
    topBar,
    banner,
    newsArchive
} from "../../src/components/index.js";

stepsList.init();
mobileMenu.init();
accordion.init();
productList.init();
productListFilters.init();
bannerCarousel.init();
bannerCarouselGreencare.init();
searchForm.init();
referenceList.init();
referenceListFilters.init();
mainMenu.init();
sidePanel.init();
shareLinks.init();
topBar.init();
banner.init();
newsArchive.init();
